import styled from 'styled-components';

import variables from '../../../styles/variables';

export const CloseModalWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 500px;
  max-height: 100%;
  padding: 10px 30px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 2px 16px 0 rgba(43, 44, 50, 0.28);
  z-index: 99999;
  transform: translate(-50%, -50%);
  overflow: auto;

  @media screen and (max-width: 768px) {
    width: 450px;
  }
  @media screen and (max-width: 550px) {
    width: 375px;
    padding-bottom: 20px;
  }
  @media screen and (max-width: 450px) {
    width: 300px;
  }
`;

export const Title = styled.h3`
  font-weight: bold;
  font-size: 24px;
  padding: 18px 0 22px 0;
  margin: 0;
  @media screen and (max-width: 550px) {
    font-size: 20px;
  }
  @media screen and (max-width: 450px) {
    font-size: 18px;
  }
`;

export const MainText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin: 25px 0;
  width: 90%;
  @media screen and (max-width: 550px) {
    /* font-size: 20px; */
  }
  @media screen and (max-width: 450px) {
    font-size: 14px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
  @media screen and (max-width: 550px) {
    justify-content: center;
  }
`;

export const NoButton = styled.button`
  cursor: pointer;
  width: 100px;
  height: 30px;
  padding: 8px 0 10px 0;
  background-color: ${variables.colorRed};
  color: ${variables.colorWhite};
  font-size: 10px;
  font-weight: 600;
  border-radius: 15px;
  box-shadow:
    0 2px 4px 0 rgba(53, 43, 43, 0.24),
    0 2px 4px 0 rgba(238, 46, 36, 0.49);
  border: none;
  margin-left: 20px;
  transition: all 0.3s;
  &:hover {
    background: ${variables.colorWhite};
    color: ${variables.colorRed};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  }
  @media screen and (max-width: 550px) {
    margin-left: 10px;
    margin-right: 0;
  }
`;

export const YesButton = styled.button`
  cursor: pointer;
  width: 100px;
  height: 30px;
  padding: 7px 0 10px 0;
  background-color: ${variables.colorWhite};
  color: ${variables.colorBlack};
  font-size: 10px;
  font-weight: 600;
  border-radius: 15px;
  border: solid 1px ${variables.colorGreyDark};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  margin-left: 20px;
  @media screen and (max-width: 550px) {
    margin-left: 0;
    margin-right: 10px;
  }
`;
